import api from "../api/api";
import {
  PANTRY_LOCATIONS_REQUEST,
  PANTRY_LOCATIONS_SUCCESS,
  PANTRY_LOCATIONS_FAIL,
  PANTRY_OPEN_ITEM_MODAL,
  PANTRY_CLOSE_ITEM_MODAL,
  PANTRY_ITEM_MODAL_ERROR,
  PANTRY_ITEM_MODAL_LOADED,
  PANTRY_SET_CREATE_DATA,
  PANTRY_OPEN_ADD_ITEM_MODAL,
  PANTRY_CLOSE_ADD_ITEM_MODAL,
  PANTRY_SET_ADD_MODAL_VIEW,
  PANTRY_RESET_STATE,
  PANTRY_CREATE_ADD_ONHAND_AMOUNT,
  PANTRY_CREATE_EDIT_ONHAND_AMOUNT,
  PANTRY_CREATE_REMOVE_ONHAND_AMOUNT,
  PANTRY_CREATE_REORDER_ONHAND_AMOUNTS,
  PANTRY_CREATE_SET_LOCATION,
  PANTRY_CREATE_SET_DATES,
  PANTRY_CREATE_SET_BRAND,
  PANTRY_CREATE_SET_PRODUCT,
  PANTRY_CREATE_SET_STORE,
  PANTRY_CREATE_SET_EXPENSE,
  PANTRY_CREATE_SET_PURCHASE,
  PANTRY_OPEN_REMOVE_ITEM_MODAL,
  PANTRY_CLOSE_REMOVE_ITEM_MODAL,
  PANTRY_OPEN_MOVE_ITEM_MODAL,
  PANTRY_CLOSE_MOVE_ITEM_MODAL,
  PANTRY_OPEN_EDIT_EXPENSE_MODAL,
  PANTRY_CLOSE_EDIT_EXPENSE_MODAL,
  PANTRY_OPEN_EDIT_PRODUCT_MODAL,
  PANTRY_CLOSE_EDIT_PRODUCT_MODAL,
  PANTRY_OPEN_EDIT_STORE_MODAL,
  PANTRY_CLOSE_EDIT_STORE_MODAL,
  PANTRY_OPEN_EDIT_ONHAND_MODAL,
  PANTRY_CLOSE_EDIT_ONHAND_MODAL,
  PANTRY_OPEN_EDIT_DATES_MODAL,
  PANTRY_CLOSE_EDIT_DATES_MODAL,
  PANTRY_REMOVE_SINGLE_REQUEST,
  PANTRY_REMOVE_SINGLE_SUCCESS,
  PANTRY_REMOVE_SINGLE_FAIL,
  PANTRY_CREATE_SINGLE_REQUEST,
  PANTRY_CREATE_SINGLE_SUCCESS,
  PANTRY_CREATE_SINGLE_FAIL,
} from "./types";

import { setAlert } from "./alert";
// Fetch all locations (with items) for a pantry, and support offset/limit slicing for infinite scroll per location
export const fetchPantryLocations = () => async (dispatch) => {
  dispatch({ type: PANTRY_LOCATIONS_REQUEST });
  try {
    const res = await api.get("/pantry/locations");
    // Prepare locations (without items)
    const locations = res.data.locations.map(({ items, total, ...rest }) => rest);
    // Prepare locationItems: { [locationId]: { ... } }
    const locationItems = {};
    res.data.locations.forEach((loc) => {
      locationItems[loc._id] = {
        loading: false,
        error: null,
        data: loc.items || [],
        offset: (loc.items && loc.items.length) || 0,
        hasMore: loc.items && loc.items.length < (loc.total || 0),
        total: loc.total || 0,
        filters: {
          name: null,
          expiry: "asc",
        },
        query: "",
      };
    });
    dispatch({
      type: PANTRY_LOCATIONS_SUCCESS,
      payload: { locations, locationItems },
    });
  } catch (err) {
    dispatch({
      type: PANTRY_LOCATIONS_FAIL,
      payload: err.response?.data?.msg || "Error loading locations",
    });
  }
};

// Fetch items for a specific location (offset-based, client-side for now)
export const fetchLocationItems =
  (locationId, { offset = 0, limit = 20 } = {}) =>
  async (dispatch) => {
    dispatch({ type: "PANTRY_LOCATION_ITEMS_REQUEST", payload: { locationId, offset, limit } });
    try {
      const res = await api.get(`/pantry/location/${locationId}/items`, {
        params: { offset, limit },
      });
      const { items, total } = res.data;
      dispatch({
        type: "PANTRY_LOCATION_ITEMS_SUCCESS",
        payload: { locationId, items, total, offset, limit },
      });
    } catch (err) {
      dispatch({
        type: "PANTRY_LOCATION_ITEMS_FAIL",
        payload: { locationId, error: err.response?.data?.msg || "Error loading items" },
      });
    }
  };
//======= MODALS =========================

//Show add item modal
export const openAddItemModal =
  ({ type, stage, location = null, pantry = null }) =>
  (dispatch) => {
    dispatch({ type: PANTRY_OPEN_ADD_ITEM_MODAL, payload: { type, stage, location, pantry } });
  };

//Hide add item modal
export const closeAddItemModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_ADD_ITEM_MODAL });
};

//Change add modal location (stage and type)
export const changeAddModalView =
  ({ type = null, stage = null }) =>
  (dispatch) => {
    dispatch({ type: PANTRY_SET_ADD_MODAL_VIEW, payload: { type, stage } });
  };

// Modal actions for pantry items
export const openItemModal = (itemID) => async (dispatch) => {
  dispatch({ type: PANTRY_OPEN_ITEM_MODAL, payload: { itemID } });

  try {
    const res = await api.get(`/pantry/item/${itemID}`);
    dispatch({ type: PANTRY_ITEM_MODAL_LOADED, payload: res.data });
  } catch (error) {
    dispatch({ type: PANTRY_ITEM_MODAL_ERROR, payload: error });
  }
};
export const closeItemModal = () => ({ type: PANTRY_CLOSE_ITEM_MODAL });
export const setItemModalError = (error) => ({ type: PANTRY_ITEM_MODAL_ERROR, payload: error });
export const setPantryItemCreateData = (data) => ({ type: PANTRY_SET_CREATE_DATA, payload: data });

// --- PantryItem onHand.amounts (ingredient aliases) actions ---
export const addOnHandAmount = (amount) => ({
  type: PANTRY_CREATE_ADD_ONHAND_AMOUNT,
  payload: amount,
});

export const editOnHandAmount = (index, updatedAmount) => ({
  type: PANTRY_CREATE_EDIT_ONHAND_AMOUNT,
  payload: { index, updatedAmount },
});

export const removeOnHandAmount = (index) => ({
  type: PANTRY_CREATE_REMOVE_ONHAND_AMOUNT,
  payload: index,
});

export const reorderOnHandAmounts = (fromIndex, toIndex) => ({
  type: PANTRY_CREATE_REORDER_ONHAND_AMOUNTS,
  payload: { fromIndex, toIndex },
});

// --- Setters for each add modal section ---
export const setCreateLocation = (locationId) => ({
  type: PANTRY_CREATE_SET_LOCATION,
  payload: locationId,
});

export const setCreateDates = ({ notifyDate, expiryDate, opened, openedDate }) => ({
  type: PANTRY_CREATE_SET_DATES,
  payload: { notifyDate, expiryDate, opened, openedDate },
});

export const setCreateBrand = (brandId) => ({
  type: PANTRY_CREATE_SET_BRAND,
  payload: brandId,
});

export const setCreateProduct = (productId) => ({
  type: PANTRY_CREATE_SET_PRODUCT,
  payload: productId,
});

export const setCreateStore = (storeId) => ({
  type: PANTRY_CREATE_SET_STORE,
  payload: storeId,
});

export const setCreateExpense = (expenseInfo) => ({
  type: PANTRY_CREATE_SET_EXPENSE,
  payload: expenseInfo,
});

export const setCreatePurchase = (purchaseInfo) => ({
  type: PANTRY_CREATE_SET_PURCHASE,
  payload: purchaseInfo,
});

// Submit pantry item creation
export const submitPantryItemCreate = () => async (dispatch, getState) => {
  const { pantry } = getState();
  const data = pantry.create.data;
  // Prepare payload for backend
  const payload = {
    pantryID: data.pantry,
    locationID: data.location,
    onHand: data.onHand,
    // Optionals:
    brand: data.brand,
    product: data.product,
    notes: data.notes,
    // Dates
    notifyDate: data.dates?.notifyDate,
    expiryDate: data.dates?.expiryDate,
    opened: data.dates?.opened,
    openedDate: data.dates?.openedDate,
    // Add more fields as needed
  };
  try {
    dispatch({ type: PANTRY_CREATE_SINGLE_REQUEST });
    const req = await api.post("/pantry/item", payload);
    dispatch({ type: PANTRY_CREATE_SINGLE_SUCCESS, payload: { locationID: data.location, items: req.data.items } });
    // Optionally close modal or show success notification here
  } catch (err) {
    console.log(err);
    // Optionally handle error
    dispatch({ type: PANTRY_CREATE_SINGLE_FAIL });
    dispatch(
      setAlert("Something went wrong when creating the item in your pantry. Please refresh and try again.", "error")
    );
    dispatch(setItemModalError(err.response?.data?.msg || "Error creating item"));
  }
};

export const resetPantryState = () => (dispatch) => {
  dispatch({ type: PANTRY_RESET_STATE });
};

//ITEM EDIT MODAL ACTIONS
export const openRemoveItemModal = (pantryItemID, locationID) => (dispatch) => {
  dispatch({ type: PANTRY_OPEN_REMOVE_ITEM_MODAL, payload: { pantryItemID, locationID } });
};
export const closeRemoveItemModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_REMOVE_ITEM_MODAL });
};

export const handleSingleOnHandRemove = (pantryItemID, locationID, removeType) => async (dispatch) => {
  try {
    dispatch({ type: PANTRY_REMOVE_SINGLE_REQUEST });
    await api.post(`/pantry/item/remove`, { items: [{ id: pantryItemID, status: removeType }] });
    dispatch({ type: PANTRY_REMOVE_SINGLE_SUCCESS, payload: { pantryItemID, locationID } });
    dispatch({ type: PANTRY_CLOSE_REMOVE_ITEM_MODAL });
    dispatch({ type: PANTRY_CLOSE_ITEM_MODAL });
  } catch (error) {
    dispatch({ type: PANTRY_REMOVE_SINGLE_FAIL });
    dispatch(setAlert("Something went wrong when removing the item. Please refresh and try again.", "error"));
  }
};

export const openMoveItemModal = () => (dispatch) => {
  dispatch({ type: PANTRY_OPEN_MOVE_ITEM_MODAL });
};
export const closeMoveItemModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_MOVE_ITEM_MODAL });
};

export const openEditExpenseModal = () => (dispatch) => {
  dispatch({ type: PANTRY_OPEN_EDIT_EXPENSE_MODAL });
};
export const closeEditExpenseModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_EDIT_EXPENSE_MODAL });
};

export const openEditProductModal = () => (dispatch) => {
  dispatch({ type: PANTRY_OPEN_EDIT_PRODUCT_MODAL });
};
export const closeEditProductModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_EDIT_PRODUCT_MODAL });
};

export const openEditStoreModal = () => (dispatch) => {
  dispatch({ type: PANTRY_OPEN_EDIT_STORE_MODAL });
};
export const closeEditStoreModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_EDIT_STORE_MODAL });
};

export const openEditOnHandModal = () => (dispatch) => {
  dispatch({ type: PANTRY_OPEN_EDIT_ONHAND_MODAL });
};
export const closeEditOnHandModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_EDIT_ONHAND_MODAL });
};

export const openEditDatesModal = () => (dispatch) => {
  dispatch({ type: PANTRY_OPEN_EDIT_DATES_MODAL });
};
export const closeEditDatesModal = () => (dispatch) => {
  dispatch({ type: PANTRY_CLOSE_EDIT_DATES_MODAL });
};
